import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { getFlowKey } from '../routing/getFlowKey';
import { isSoftwareSignup } from '../store/flow/selectors';
import { Step } from '../views/Step';
import { getLandingPageTitle } from './getLandingPageText';
import { getIntegrationName } from '../utils/getIntegrationName';
import { H1 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { OptionalFormattedMessage } from '../views-components/OptionalFormattedMessage';
import { LandingPageSubtitle, LandingPageTitleWrapper } from './LandingPageView';
export const renderLandingPageTitle = ({
  isMobile
}) => {
  const flowKey = getFlowKey();
  const {
    title,
    titleLabel,
    subtitleLabel
  } = getLandingPageTitle(flowKey);
  const defaultMobileSubtitle = `views.${Step.LandingPage}.mobileSubtitle.default`;
  const subtitle = isMobile && isSoftwareSignup() ? defaultMobileSubtitle : subtitleLabel;
  return /*#__PURE__*/_jsxs(LandingPageTitleWrapper, {
    className: `text-center m-x-auto flex-column justify-center`,
    shouldSetMaxWidth: !isValidI18nKey(titleLabel),
    children: [/*#__PURE__*/_jsx(H1, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: title,
        options: {
          integratorName: getIntegrationName()
        }
      })
    }), /*#__PURE__*/_jsx(LandingPageSubtitle, {
      children: /*#__PURE__*/_jsx(OptionalFormattedMessage, {
        message: subtitle
      })
    })]
  });
};